import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { DataService } from 'src/app/core/services/data.service';
import { converterTAttendance, ConvertService, keyOnlyConverterDetail } from '../services/convert.service';
import { MappingService, pushToArray } from '../services/mapping.service';

@Pipe({
  name: 'batchGroup'
})
export class BatchGroupPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return value.filter(m => m.batchKey === args)
    }
    return null;
  }

}


@Pipe({
  name: 'filterHour'
})
export class FilterHourPipe implements PipeTransform {
  transform(item: any, day): any {
    if (item && day) {
      let data: any = [];
      for (const d of day) {
        const gethour = item.filter(m => m.days[d] === true).map(a => ({ ...a, day: d }));
        data.push(...gethour)
      }
      return data ? MappingService.orderBy(data, 'fromHoursNumber') : null
    }
    return null;
  }

}

@Pipe({
  name: 'dayText'
})
export class DayTextPipe implements PipeTransform {
  transform(item: any, day): any {
    if (item) {
      const toArraysDays = Object.keys(item).map(function (key) {
        return { name: key, value: item[key] };
      });
      const data: any = toArraysDays.filter(m => m.value === true);
      // for (const d of day) {
      // data.push(...gethour)
      //   const gethour = item[d] === true ? Object.keys(item[d]) : null
      //   data = gethour
      // }
      return data.name
      // return data ? MappingService.orderBy(data, 'fromHoursNumber') : null
    }
    return null;
  }

}

@Pipe({
  name: 'totalSAttendence'
})
export class TotalSAttendencePipe implements PipeTransform {
  constructor(private ds: DataService) { }
  async transform(sc, item, fdate, tdate): Promise<any> {
    const fromDateKey = moment(fdate).startOf('day').toDate();
    const toDateKey = moment(tdate).endOf('day').toDate();

    if (!item) return null;
    const data = await this.ds.academicYearFireRefCollection().doc(sc.academicYear.key).collection('schedules').doc(sc.key).collection('attendance').where('sessionKey', '==', item.key).where('created_at', '>=', fromDateKey).where('created_at', '<=', toDateKey).withConverter(keyOnlyConverterDetail).get();
    const alldata = pushToArray(data)

    if (alldata.length === 0) return 0;
    const sdata = await this.ds.academicYearFireRefCollection().doc(sc.academicYear.key).collection('schedules').doc(sc.key).collection('attendance').doc(alldata[0].key).collection('students').withConverter(converterTAttendance).get();
    const allsdata = pushToArray(sdata)

    const { day } = item
    let total = 0
    allsdata.map(m => {
      const dayC = ConvertService.getDayString(m.date_key)
      if (dayC === ConvertService.toLowerCase(day)) {
        total += 1
      }
    })

    return total > 0 ? total : '';
  }

}

@Pipe({
  name: 'totalTAttendance'
})
export class TotalTAttendancePipe implements PipeTransform {
  constructor(private ds: DataService) { }
  async transform(sc, item, fdate, tdate): Promise<any> {
    const fromDateKey = moment(fdate).startOf('day').toDate();
    const toDateKey = moment(tdate).endOf('day').toDate();

    if (!item) return null;
    const data = await this.ds.academicYearFireRefCollection().doc(sc.academicYear.key).collection('schedules').doc(sc.key).collection('attendance').where('sessionKey', '==', item.key).where('created_at', '>=', fromDateKey).where('created_at', '<=', toDateKey).withConverter(converterTAttendance).get();
    const allData = pushToArray(data)
    const allTData = MappingService.groupBy(allData, "date_key", "date_key")

    const { day } = item
    let total = 0
    allTData.map(m => {
      const dayC = ConvertService.getDayString(m.date_key)
      if (dayC === ConvertService.toLowerCase(day)) {
        total += 1
      }
    })

    return total > 0 ? total : '';
  }

}
